// 네임스페이스별 사전을 한데 모은다. 파일 이름 = t() 키의 첫 조각.
// 각 파일은 { ko: {...}, en: {...} } 를 default export 한다.
import common from "./common";
import information from "./information";
import mission from "./mission";
import scheduler from "./scheduler";
import data from "./data";
import energy from "./energy";
import map from "./map";
import demo from "./demo";

const namespaces = { common, information, mission, scheduler, data, energy, map, demo };

export const messages = { ko: {}, en: {} };
for (const [ns, dict] of Object.entries(namespaces)) {
  messages.ko[ns] = dict.ko ?? {};
  messages.en[ns] = dict.en ?? {};
}
